import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { isDevMode } from '@angular/core';
import {
  registerDevelopmentServiceWorker,
  registerProductionServiceWorker,
} from './service-worker-registration';

// Use async IIFE to support environments without top-level await
(async () => {
  try {
    await bootstrapApplication(App, appConfig);

    if ('serviceWorker' in navigator) {
      if (isDevMode()) {
        registerDevelopmentServiceWorker();
      } else {
        registerProductionServiceWorker();
      }
    }
  } catch (err) {
    console.warn(err);
  }
})();
